export const stats = [
  { value: '500+', label: 'Ready-to-Use Units & Worksheets' },
  { value: '1,200+', label: 'Satisfied Teachers' },
  { value: '4,500+', label: 'Prep Hours Saved' },
  { value: '98%', label: 'Recommendation Rate' },
]

export const differenceStats = [
  { value: '500+', label: 'Ready-to-Use Units & Activities (Year 1 to Year 6)' },
  { value: '6', label: 'Complete Digital Volumes (Interactive PDF)' },
  { value: '100%', label: 'Immediate Download' },
]

export const beforeItems = [
  'Hours spent creating balance sheets and exercises that "balance" on Excel every single Sunday',
  'Confusing lessons due to a lack of visual support for abstract concepts like depreciation or equity',
  'No real connection between textbook theory and practical modern accounting software or digital taxes',
  'Stressful nights creating inclusive assessments (Special Needs/IEP) from scratch',
  'Unmotivated students who think "accounting is just a list of boring numbers"',
]

export const afterItems = [
  '5 minutes of review and you’re ready to enter the classroom with the confidence of a professional',
  'Modern visual charts that make double-entry bookkeeping clear at first glance',
  'Real business cases integrated into every single teaching unit',
  'Quizzes, tests, solutions, and rubrics 100% ready: no more last-minute calculation errors',
  'Students who understand the value of business, know how to read a financial statement, and feel ready for the professional world',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: "Double-Entry Anxiety: arriving in class fearing that a complex exercise won't balance in front of the students",
  },
  {
    emoji: '⏱️',
    text: 'Sundays in the Office: spending your entire weekend creating T-accounts and journal entries instead of being with your family',
  },
  {
    emoji: '🤷',
    text: 'Operational Chaos: struggling to find updated, visual examples of invoices or corporate financial statements',
  },
  {
    emoji: '📋',
    text: 'Infinite Grading: no clear assessment rubrics or tests aligned with the curriculum',
  },
  {
    emoji: '😴',
    text: 'Lost Students: learners giving up because accounting feels like an incomprehensible language',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 PDF Volumes Based on the School Year (Year 1 – Year 6)',
    text: 'A complete curriculum: from Year 1 commercial foundations to Year 6 advanced corporate reporting',
  },
  {
    emoji: '🧾',
    title: 'Visual Documents & Recording Kit',
    text: 'Templates for invoices, shipping docs, and Journal entry schemas ready to project or print',
  },
  {
    emoji: '✏️',
    title: '«Instant-Flow» Lesson Scripts',
    text: 'Teaching tips that tell you exactly how to introduce difficult concepts like corporate consolidations',
  },
  {
    emoji: '📐',
    title: 'Visual Accounting: Maps & Charts',
    text: 'Modern infographics to explain management flows, income, and equity without tiring the eyes',
  },
  {
    emoji: '📊',
    title: 'Assessments, Solutions & Inclusion Tools',
    text: 'Complete evaluation tools and simplified versions for a truly inclusive classroom',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Every single exercise is accompanied by its detailed solution: instant corrections and zero stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/4H6exCzGcGpPa7y9d1GafW/Captura-de-pantalla-2026-09-08-a-las-9.58.27_p._m..webp',
    level: 'Year 1 · Foundations',
    title: 'Unit 2 Activities: Solving the Accounting Equation',
    caption:
      'Four activities of increasing difficulty: find the missing equity for five startups, review the real equations of Apple, Nike and a local bakery, build your own business, and lay it all out in a T-account.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wnB1nknyWNxXy6Ni9VW2fu/Captura-de-pantalla-2026-09-08-a-las-9.59.45_p._m..webp',
    level: 'Year 2 · The Cycle',
    title: 'Unit 5: Preparing the Unadjusted Trial Balance',
    caption:
      'A full worked trial balance for Rachel’s Cleaning Service, with every account colour-coded by debit and credit so students can see the $45,800 totals match before any adjustments.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ezTj6tV3brhetGbaEqc5z4/Captura-de-pantalla-2026-09-08-a-las-10.00.20_p._m..webp',
    level: 'Year 3 · Merchandising',
    title: 'Unit 2: Merchandise Purchases & Sales Cycle',
    caption:
      'Cash versus credit purchases side by side, each with its journal entry, T-accounts and warning box, closed by a Day 1 to Day 30 timeline of the payment on account.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rRtdvQQsMzZAL2bgvAb82V/Captura-de-pantalla-2026-09-08-a-las-10.02.57_p._m..webp',
    level: 'Year 4 · Reporting',
    title: 'Unit 7: Comprehensive Ratio Analysis & Benchmarking',
    caption:
      'A dashboard view grouping profitability, liquidity, efficiency and solvency ratios, each flagged as healthy or watch-out, with a written assessment of the company overall.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8mPbpxg6shgvKms8ccLzvy/Captura_de_pantalla_2026-09-08_a_las_10.21.43_p.webp',
    level: 'Year 5 · Managerial',
    title: 'Fixed, Variable and Mixed Costs: Detailed Comparison',
    caption:
      'Three cost behaviours compared column by column with real examples, plotted graphs, a worked electricity calculation and the formula for each one.',
  },
]

export const bonuses = [
  {
    title: 'Annual Class Planner',
    was: '$17',
    text: 'Your entire school year mapped out. Know exactly what to teach and when, without the Sunday stress',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7c7c92bc-66bb-4186-ad3b-e97e460042aa.jpg',
  },
  {
    title: 'Visual Flashcards Pack',
    was: '$17',
    text: 'High-impact visual aids for students to master accounting terminology and T-account rules fast',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/04179f42-d2b3-4c23-b2c3-2f9bbdd9a918.jpg',
  },
  {
    title: 'Worksheet Vault',
    was: '$17',
    text: 'A massive collection of extra practice sheets for every topic, perfect for homework or fast-finishers',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/c7c719e8-f693-4a12-ba0d-df95519cc43a.jpg',
  },
  {
    title: 'Assessment & Answer Key Toolkit',
    was: '$17',
    text: 'Professional tests with their respective solutions. Grade in half the time with zero errors',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/08312a01-81d4-43f7-bd58-835fe3ea4484.jpg',
  },
  {
    title: 'Classroom Visual Posters Pack',
    was: '$17',
    text: 'Beautify your classroom with educational posters that reinforce key accounting concepts daily',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7f455af9-7f97-4b9e-8249-81403645dfcb.jpg',
  },
]

export const offerRows = [
  { label: 'ACCOUNTING READY™ (6 Digital PDF Volumes)', value: '$97' },
  { label: '5 Exclusive Strategic Bonuses', value: '$85' },
]

export const testimonials = [
  {
    quote:
      'Finally, my students understood double-entry bookkeeping thanks to the visual charts. I got my weekends back!',
    name: 'Sarah M.',
    location: 'High School Teacher',
  },
  {
    quote:
      'The ready-to-print tests were a game-changer for my class. Everything balanced perfectly.',
    name: 'James L.',
    location: 'Business Studies Teacher',
  },
  {
    quote:
      'The Visual Flashcards helped my students finally memorize the rules of Debit and Credit. Highly recommended!',
    name: 'Emily R.',
    location: 'Accounting Teacher',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: 'Instant download link via email.',
  },
  {
    q: 'Is it updated?',
    a: 'Yes, updated for the 2026 school year.',
  },
  {
    q: 'Can I print the PDFs?',
    a: 'Yes, high-quality print-ready files.',
  },
  {
    q: 'Does it cover all years?',
    a: 'Yes, from Year 1 to Year 6.',
  },
]
